import React, { useState } from "react";
import { Link } from "react-router-dom";
import logoImg from '../assets/Union.png'
import { Button } from "ui-kit-takeat";
const Header = ({ handleLogout }) => {
  const [butao, setButao] = useState(false);

  return (
    <header className="header">

     

      
      
      <img src={logoImg} alt="Logo" className="header-logo" />

      <nav className="nav-menu">
          <Link to="/panel" onClick={() => setButao(false)}>Painel</Link>
          <Link to="/general" onClick={() => setButao(false)}>Informações Gerais</Link>
          <Link to="/sucesso" onClick={() => setButao(false)}>Sucesso</Link>
        </nav>
      <Button title= "Sair" onClick ={handleLogout} style={{position:'absolute',left:20}} inverted buttonColor='#FFFFFF'/> 
    </header>
  );
};

export default Header;



